module.exports = __webpack_public_path__ + "static/media/vvs_viceprez.d69a0b04.jpg";